import type { MediumType } from '@shared/api/rtkQuery/contentTemplate'

const shouldRedirectByMediumType = (mediumType: MediumType | null) =>
  Boolean(mediumType && mediumType !== 'email')

export default shouldRedirectByMediumType
